import { render, staticRenderFns } from "./RelFinFluxoCaixa.vue?vue&type=template&id=959765b4"
import script from "./RelFinFluxoCaixa.vue?vue&type=script&lang=js"
export * from "./RelFinFluxoCaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports